import {useWrapperStyle} from '../store/selectors';
import {useIsMobileView} from './useIsMobileView';

/**
 * True for an INLINE grid on desktop. Such a grid has no card frame, so its
 * toolbar, preset strip and pagination row keep only INLINE_EDGE_INSET at the
 * grid edges and their controls line up with the table edges. CARD grids keep
 * the card insets. Mobile grids never have a frame and keep their own insets.
 */
export function useIsInlineDesktop(): boolean {
  const wrapperStyle = useWrapperStyle();
  const isMobile = useIsMobileView();
  return wrapperStyle === 'INLINE' && !isMobile;
}
